import React from 'react'

import { SubmitProps } from './Submit.types'
import { useFormContext } from '../../Form/FormContext'

import Button from '../../Button/Button'
/**
 * Connects to a form to initiate the submit process. The underlying component is the 'Button' component
 */
const Submit: React.FC<SubmitProps> = (props) => {
    const label = props.label || 'Submit'
    const form = useFormContext()

    const handleClick = (e) => {
        e.preventDefault()
        if (form) {
            form.submit()
        }
        if (props.onClick) {
            props.onClick(e)
        }
    }

    return <Button label={label} {...props} onClick={handleClick} />
}

export default Submit
